import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  navigationTree: { data: [], list: [], loading: false },
  publishedTree: { data: [], list: [], loading: false },
  versionTree: { data: [], list: [], loading: false },
  categoryTree: { data: [], loading: false },
  versionList: { data: [], loading: false },
  labelList: { data: [], loading: false },
  previewList: { data: [], loading: false },
  entityTypes: { data: [], loading: false },
  dialog: { visible: false, loading: false, type: '', data: null },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
